import { apiClient } from './client';
import type { LoaAlignmentResponse } from '@/types/oscar';

/** The Levels of Authority matrix laid beside today's DAL / PO limits. Read-only. */
export function getLoaAlignment(signal?: AbortSignal): Promise<LoaAlignmentResponse> {
  return apiClient.get<LoaAlignmentResponse>('/api/loa-alignment', signal);
}
